import { gql } from '@apollo/client'
import { scoreGridFragment } from '../score-grid/fragments/scoreGridFragment'
import countrySettingsFragment from '../countrySettings/countrySettings.fragment'

export const EMPLOYEES_WITH_LATEST_AND_DRAFT_SCORE_GRID = gql`
  query GetEmployeesWithLatestAndDraftScoreGrid($companyId: HashedId!, $country: Country!) {
    getEmployeesWithLatestAndDraftScoreGrid(companyId: $companyId, country: $country) {
      id
      globalId
      employee {
        id
        firstName
        lastName
        avatarUrl
        currentLevel
        companyName
        buName
      }
      businessUnit {
        id
        name
        displayName
      }
      latestEvaluation
      existingLatestEvaluation
      draftEvaluation
      existingDraftEvaluation
      scoreGridStatus
      scoreGoals {
        id
        viewId
        resultEvaluation
      }
    }
    getCountryEmployeeLevels(country: $country)
    getCountrySettings(country: $country) {
      ...CountrySettings
    }
    getIdVWeightsByCountry(companyId: $companyId, country: $country) {
      country
      level
      value
      weight
    }
  }
  ${countrySettingsFragment}
`

export const DRAFT_OR_LATEST_SCORE_GRID_BY_EMPLOYEE = gql`
  query GetDraftOrLatestScoreGridByEmployee($companyId: HashedId!, $country: Country!, $employeeId: HashedId!) {
    getDraftOrLatestScoreGridByEmployee(companyId: $companyId, country: $country, employeeId: $employeeId) {
      ...ScoreGridFragment
    }
  }
  ${scoreGridFragment}
`

export const LATEST_SCORE_GRID_BY_EMPLOYEE = gql`
  query GetLatestScoreGridByEmployee($companyId: HashedId!, $country: Country!, $employeeId: HashedId!) {
    getLatestScoreGridByEmployee(companyId: $companyId, country: $country, employeeId: $employeeId) {
      ...ScoreGridFragment
    }
  }
  ${scoreGridFragment}
`

export const FIND_BUSINESS_UNITS_BY_COMPANY = gql`
  query FindCurrentBusinessUnitsByCompanyId($companyId: HashedId!, $country: Country!) {
    findCurrentBusinessUnitsByCompanyId(companyId: $companyId, country: $country) {
      id
      name
      displayName
    }
  }
`
